import { deepMerge, getTargetOffsetTop } from 'js/utils/Utils'
import { Mesh, RawShaderMaterial, DoubleSide } from 'three'

import VertexShader from 'js/webgl/_glsl/vert/default/default.vert'
import FragmentShader from 'js/webgl/_glsl/frag/default/default.frag'
import Common from 'js/_core/Common'

const defaults = {
  vs: VertexShader,
  fs: FragmentShader,
  geometry: null,
  material: null,
  materialOption: {
    depthTest: false,
    transparent: true,
    alphaTest: 0.5,
    wireframe: false,
  },
}

export default class BasePlaneMesh {
  constructor(options = {}) {
    this.vs = null
    this.fs = null

    this.mesh = null
    this.uniforms = {
      uTime: { value: 0 },
      uOpacity: { value: 0 },
      uStageResolution: {
        value: {
          x: 0,
          y: 0,
        },
      },
      uMeshResolution: {
        value: {
          x: 1,
          y: 1,
        },
      },
    }

    this.isInView = false

    deepMerge(this, defaults, options)
  }

  init() {
    this.material = new RawShaderMaterial(
      deepMerge(
        {
          vertexShader: this.vs,
          fragmentShader: this.fs,
        },
        this.materialOption
      )
    )

    this.material.uniforms = this.uniforms
    this.material.side = DoubleSide
    this.mesh = new Mesh(this.geometry, this.material)

    // this._setMeshSize()
  }

  destroy() {
    if (this.mesh) {
      Common.webgl.stage.scene.remove(this.mesh)

      if (this.material) {
        this.material.dispose()
      }

      if (this.mesh && this.mesh.material) {
        this.mesh.material.dispose()
      }

      if (this.geometry) {
        this.geometry.dispose()
      }

      if (this.mesh && this.mesh.geometry) {
        this.mesh.geometry.dispose()
      }

      this.mesh = null
    }
  }

  _setMeshSize() {}

  _setBaseSize() {
    this.uniforms.uStageResolution.value.x = Common.webgl.stage.stageSize.width
    this.uniforms.uStageResolution.value.y = Common.webgl.stage.stageSize.height
  }

  async _enterAnimation() {}

  async _leaveAnimation() {}

  _startMouseEnter() {
    this.isMouseEnterAnimating = true

    this._enterAnimation().then(() => {
      this._completeMouseEnter()
    })
  }

  _startMouseLeave() {
    this.isMouseEnterAnimating = true

    this._leaveAnimation().then(() => {
      this._completeMouseLeave()
    })
  }

  _completeMouseEnter() {
    this.isMouseEnterAnimating = false

    if (!this.isMouseEnter) {
      this._startMouseLeave()
    }
  }

  _completeMouseLeave() {
    this.isMouseEnterAnimating = false
    if (this.isMouseEnter) {
      this._startMouseEnter()
    }
  }

  onResize() {
    this._setBaseSize()
    this._setMeshSize()
  }

  onRaf() {}
}